/**
 * Function that is used as a  formatted error containing the
 * message and errors from a failed action.
 *
 * Ex. Trying to create a new card and the response contains an error.
 * `throw new FullError(response)`
 *
 * After throwing the error you can access it within a `catch` statement.
 * There will be a error.message, and error.errors that contains specific errors
 *
 * @param {object} errorResponse - Response from an API action that contains errors
 */
export function FullError(errorResponse) {
  this.message = errorResponse.error || ''
  this.errors = (errorResponse.errors && errorResponse.errors.base) || ''
}
